import React from 'react';
import { HealthView } from '@/components/shared/ReuseableHealth';
import { useGetMyMicrobiomeDetail } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { ErrorLoadingPage } from '../ErrorHandling/ErrorLoadingPage';

export const OralMicrobiomePage: React.FC = () => {
  const { data, isError, isLoading } = useGetMyMicrobiomeDetail('oral');

  if (isError) {
    return <ErrorLoadingPage variant="dark" />;
  }

  return (
    <HealthView
      profileData={data || null}
      isLoading={isLoading}
      buttonText="My oral microbes"
      onClickPath="/active-microbes?type=oral"
      type="oral"
    />
  );
};
